<template>
  <router-link :to="{path:'ProductDetail' , query:{productId : item.ProductId}}"
               class="d-block third-bg rounded-lg book-card">
    <div class="row mx-1 position-relative">
      <div class="col-5 px-1">

        <v-img :src="$replaceHttps(item.MainFileUrl200)" class="" contain>

        </v-img>
        <span v-if="item.DiscountPercent !== 0"
              class="font-12 red white--text rounded-circle p-1 d-inline-block position-absolute discount-badge">
         {{ item.DiscountPercent }} %
         </span>
      </div>
      <div class="col-7 px-1">
        <div class="text-center mt-2 font-weight-bold black--text">
          {{ item.Name }}
        </div>
        <div class="text-center mt-2 light-gray-text   pt-4">
          <div>
            <div v-if="item.Price != 0"
                 :class="item.DiscountPercent  == 0 ?'' : 'text-decoration-line-through font-font-10 grey--text'">
              <span> {{ $numberWithCommas(item.Price) }} تومان</span>
            </div>
            <span v-if="item.Price == 0"> رایگان</span>
            <span :class="(item.DiscountPercent  != 0 )  ? '' : 'visibility-hidden'">
              <div :class="(item.Price != 0 )  ? '' : 'visibility-hidden'">
                {{ $computingPriceOffer(item.Price, item.DiscountPercent) }} تومان
              </div>
            </span>
          </div>
          <v-btn class="mt-6" color="secondary" elevation="0" small @click.prevent.stop="addToCart(item.ProductId)">
             <span class="primary-text font-12">
            <i class="fa-solid fa-cart-circle-plus pt-1"></i>
            </span>
          </v-btn>
        </div>
      </div>
      <v-dialog
          v-model="showResultDialog"
          hide-overlay
          persistent
          width="530">
        <v-card class="text-center">
          <v-card-title class="justify-space-between secondary-bg">
            <v-btn
                color="primary"
                icon
                @click="showResultDialog = false">
              <i class="fas fa-times ml-1"></i>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-overlay
          v-model="showLoaderDialog"
          persistent
          width="500">
        <v-progress-circular
            color="white"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>
    </div>


  </router-link>
</template>

<script>
export default {
  name: "BooksCard",
  props: ['item'],
  data: () => ({
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: null
  }),
  mounted() {
    // this.silentLogin()
  },
  methods: {
    /*silentLogin() {
      let userData = this.$getUserData()
      console.log(userData)
      if (userData.mobile !== '' && userData.activeCode !== '' && userData.mobile !== undefined && userData.activeCode !== null) {
        console.log("11111")
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userData.mobile);
        urlencoded.append("VerifyCode", userData.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/LoginRegister", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                console.log(json)
                let token = 'Bearer ' + json.JwtToken
                console.log(token)
                this.$setUserData(userData.mobile, userData.activeCode, token, json.Role);
                this.isLoggedIn = true;
                if (json.Role === 1 || json.Role === 2 || json.Role === 3) {
                  this.$router.replace({path: '/Dashboard'})
                }
              } else {
                this.isLoggedIn = false
              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
      }


    },*/
    addToCart(id) {
      let resStatus = null
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("productId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/AddProductToCart", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          }).then(result => {
        if (resStatus === 401) {
          this.showResultDialog = true
          this.dialogResult = 'برای اضافه کردن محصول به سبد خرید ابتدا باید وارد سایت شوید.'
        }
        if (resStatus === 200) {
          this.showResultDialog = true
          this.dialogResult = result
          setTimeout(function (){
            window.location.reload();
          },1000);
        }

      })
          .catch(error => console.log('error', error));

    }
  }
}
</script>

<style scoped>

</style>
